import { Link } from "react-router-dom";
import { ArrowRight, Trophy } from "lucide-react";
import { Reveal } from "@/components/site/Reveal";

export default function WinnerSpotlightBand() {
  return (
    <section data-testid="winner-spotlight-band" className="border-y border-[#D4AF37]/25 bg-[#0A0A0A]">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-6 py-24 lg:grid-cols-2 lg:gap-20 lg:px-10">
        <Reveal>
          <div className="clipped-frame overflow-hidden">
            <img
              src="/brand/taufiq-valentina.jpg"
              alt="Taufiq Mansoor Ansari with Valentina Mishra after his international win"
              data-testid="spotlight-band-image"
              className="max-h-[560px] w-full bg-black object-contain transition-transform duration-700 hover:scale-105"
            />
          </div>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="flex items-center gap-3">
            <Trophy className="h-5 w-5 text-[#D4AF37]" strokeWidth={1} />
            <span className="font-script text-3xl text-[#D4AF37]">Winner Spotlight</span>
          </div>
          <h3 data-testid="spotlight-band-name" className="font-display mt-5 text-4xl font-medium text-white md:text-5xl">
            Taufiq Mansoor Ansari
          </h3>
          <p className="mt-4 text-[11px] uppercase tracking-[0.3em] text-[#D4AF37]/80">
            Top Child Model of the Planet — India 2019 · Grand Prix, Tbilisi
          </p>
          <p className="font-display mt-8 text-xl font-light italic leading-relaxed text-neutral-300">
            “I was so introverted, with terrible stage fear — but ma’am groomed me so well that I won
            the title for India. It was only because of Valentina ma’am.”
          </p>
          <Link
            to="/winners/taufiq-mansoor-ansari"
            data-testid="spotlight-band-link"
            className="mt-10 inline-flex items-center gap-3 border border-[#D4AF37]/60 px-8 py-4 text-xs uppercase tracking-[0.3em] text-[#D4AF37] transition-all duration-300 hover:bg-[#D4AF37] hover:text-black"
          >
            Read His Full Story <ArrowRight className="h-4 w-4" strokeWidth={1} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
}
